<script setup lang="ts">
/**
 * `Service` cell of the mobile performer-stats sub-table: the service name
 * with the group and its age on one sub-line below (so a session takes two
 * lines, not three). A long group name is truncated with an ellipsis; the
 * age never shrinks. Mirrors `docs/sketches/mobile/performers-stat-table.html`.
 */
defineProps<{
  serviceName: string
  /** Group display name; '' when the service has no group (sub-line is omitted). */
  groupName: string
  /** Group age at the end of the period. */
  groupAge: string
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()
</script>

<template>
  <td class="font-tufte" :style="maxWidth ? { maxWidth: maxWidth } : undefined">
    <div class="stuff-mobile-service__name">{{ serviceName }}</div>
    <div v-if="groupName" class="stuff-mobile-service__group-line">
      <span class="stuff-mobile-service__group" :title="groupName">{{ groupName }}</span>
      <span class="stuff-mobile-service__age">{{ groupAge }}</span>
    </div>
  </td>
</template>

<style scoped>
.stuff-mobile-service__group-line {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  max-width: 130px;
  margin-top: 0.1rem;
  font-family: var(--font-tufte-sans);
  font-size: var(--text-tufte-xs);
}

.stuff-mobile-service__group {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stuff-mobile-service__age {
  flex: 0 0 auto;
  white-space: nowrap;
  color: var(--color-tufte-muted);
}
</style>
